export default __webpack_public_path__ + "static/media/chev-right-blue.436b8321.svg";